<div class="h-full flex flex-col justify-start items-center overflow-hidden">
    @if (getStreamService.chatIsReady$ | async) {
    <div
        class="flex h-full min-h-0 w-full flex-col gap-2 overflow-hidden lg:grid lg:grid-cols-5 lg:gap-4">
        <div
            class="inbox-channel-pane flex w-full shrink-0 flex-col gap-y-2 overflow-hidden card-container-pale lg:col-span-2 lg:h-full lg:min-h-0 lg:divide-y lg:divide-zinc-200 dark:lg:divide-zinc-600">

            <!-- Header -->
            <div class="flex shrink-0 flex-row items-center pb-2 lg:pb-4">
                <div class="grid w-full grid-cols-1">
                    <input [formField]="inboxSearchQueryForm.query" id="inbox-search" type="text" placeholder="Inbox Search"
                        class="input-icon text-primary" />
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 sm:size-4">
                        <path d="m21 21-4.34-4.34" />
                        <circle cx="11" cy="11" r="8" />
                    </svg>
                </div>
            </div>
            <!-- Header - END-->

            <!-- Main Content -->
            <div class="inbox-channel-list-wrap min-h-0 w-full overflow-hidden lg:flex-1">
                <!-- Inbox List -->
                <stream-channel-list class="inbox-channel-list block w-full lg:h-full"> </stream-channel-list>
                <!-- Inbox List - END -->
            </div>
            <!-- Main Content - END-->

        </div>

        <div class="flex min-h-0 w-full flex-1 flex-col gap-y-2 overflow-hidden lg:col-span-3 lg:h-full">

            @if (getStreamService.hasActiveChannel()) {
            <!-- Header -->
            <div
                class="flex shrink-0 flex-col gap-2 overflow-hidden p-3 card-container-pale lg:flex-row lg:items-center lg:p-4">

                <div class="flex min-w-0 w-full flex-1 flex-row items-center gap-x-4">
                    <stream-channel-header class="min-w-0 flex-1"></stream-channel-header>
                </div>

                <div class="flex shrink-0 flex-row items-center gap-x-2 overflow-x-auto">
                    <atom-channel-info-drawer class="shrink-0"></atom-channel-info-drawer>
                    @if (canShowContentButton()) {
                    <button (click)="viewCreatorProfile()" type="button" aria-label="Profile"
                        class="inline-flex items-center gap-x-1.5 secondary-button text-primary">
                        <span class="hidden lg:inline">Profile</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 lg:-ml-0.5">
                            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                            <circle cx="12" cy="7" r="4" />
                        </svg>
                    </button>

                    <button (click)="viewSubmission()" type="button" aria-label="Content"
                        class="inline-flex items-center gap-x-1.5 primary-button">
                        <span class="hidden lg:inline">Content</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 lg:-mr-0.5">
                            <rect width="18" height="14" x="3" y="3" rx="2" />
                            <path d="M4 21h1" />
                            <path d="M9 21h1" />
                            <path d="M14 21h1" />
                            <path d="M19 21h1" />
                        </svg>

                    </button>

                    <button (click)="goToBrief()" type="button" aria-label="Brief"
                        class="inline-flex items-center gap-x-1.5 primary-button">
                        <span class="hidden lg:inline">Brief</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 lg:-mr-0.5">
                            <path
                                d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                            <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                            <path d="M9 15h6" />
                            <path d="M12 18v-6" />
                        </svg>

                    </button>
                    }
                </div>

            </div>
            <!-- Header - END-->

            <!-- Main Content -->
            <div class="flex min-h-0 flex-1 flex-col items-center overflow-hidden">
                <div class="flex h-full min-h-0 w-full flex-col overflow-hidden card-container-pale-no-padding chat-body">
                    <stream-channel class="h-full w-full flex flex-col overflow-hidden rounded-lg">
                        <div class="flex-1 overflow-y-auto">
                            <stream-message-list class="h-full"></stream-message-list>
                        </div>
                        <div id="input-container" class="shrink-0">
                            <!-- <stream-message-input [autoFocus]="false" class="w-full"></stream-message-input> -->
                            <stream-message-input>

                            </stream-message-input>
                        </div>
                    </stream-channel>
                </div>
            </div>
            <!-- Main Content - END-->
            } @else {
            <div class="h-full flex flex-col items-center justify-center card-container-pale-no-padding">
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                        class="mx-auto size-12 text-gray-500">
                        <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
                        <path
                            d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
                    </svg>
                    <h3 class="mt-2 text-sm font-semibold text-primary">No chat selected</h3>
                    <p class="mt-1 text-sm text-secondary lg:hidden">Select a chat above.</p>
                    <p class="mt-1 hidden text-sm text-secondary lg:block">Select a chat on the left.</p>

                </div>

            </div>
            }


        </div>
    </div>
    } @else {
    <div class="h-full w-full flex flex-col justify-center py-12">
        <atom-loading-inline title="Loading Inbox" message="Loading chats..."></atom-loading-inline>
    </div>
    }
</div>

@if (magicSearchService.portfolioCreatorId()) {
<cc-creator-profile [creator]="magicSearchService.portfolioCreator()!"></cc-creator-profile>
}